export class GuidHelper {    
    static NewGuid() {
        let date = new Date().getTime();
        let guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            let randomValue = (date + Math.random() * 16) % 16 | 0;
            date = Math.floor(date / 16);
            
            return (c == 'x' ? randomValue : (randomValue & 0x3 | 0x8 )).toString(16);
        });
        return guid;
    };
}